import React from 'react';
import './TechMarquee.css';

// Verified working icons
import {
  SiPython, SiJavascript, SiHtml5, SiCss3, SiC, SiCplusplus,
  SiGnubash, SiMysql, SiReact, SiVuedotjs, SiSpringboot,
  SiExpress, SiNodedotjs, SiThreedotjs, SiNginx, SiGit, SiGithub,
  SiLinux, SiDocker, SiUnity, SiOpencv, SiGithubactions,
  SiDigitalocean, SiJenkins, SiKubernetes, SiJson
} from 'react-icons/si';

import { FaJava, FaAws } from 'react-icons/fa';
import { VscAzure, VscTerminalPowershell } from 'react-icons/vsc';
import { TbBrandCSharp } from 'react-icons/tb';

const technologies = [
  // Languages
  { name: 'Java', icon: FaJava },
  { name: 'Python', icon: SiPython },
  { name: 'JavaScript', icon: SiJavascript },
  { name: 'HTML', icon: SiHtml5 },
  { name: 'CSS', icon: SiCss3 },
  { name: 'C', icon: SiC },
  { name: 'C#', icon: TbBrandCSharp },
  { name: 'C++', icon: SiCplusplus },
  { name: 'Bash', icon: SiGnubash },
  { name: 'PowerShell', icon: VscTerminalPowershell },
  { name: 'SQL', icon: SiMysql },

  // Technologies
  { name: 'React', icon: SiReact },
  { name: 'Vue', icon: SiVuedotjs },
  { name: 'Spring Boot', icon: SiSpringboot },
  { name: 'Express.js', icon: SiExpress },
  { name: 'Node.js', icon: SiNodedotjs },
  { name: 'Three.js', icon: SiThreedotjs },
  { name: 'REST API', icon: SiJson },
  { name: 'Nginx', icon: SiNginx },

  // Tools & Platforms
  { name: 'GitHub', icon: SiGithub },
  { name: 'Linux', icon: SiLinux },
  { name: 'AWS', icon: FaAws },
  { name: 'Azure', icon: VscAzure },
  { name: 'Docker', icon: SiDocker },
  { name: 'Unity', icon: SiUnity },
  { name: 'OpenCV', icon: SiOpencv },
  { name: 'GitHub Actions', icon: SiGithubactions },
  { name: 'DigitalOcean', icon: SiDigitalocean },
  { name: 'Jenkins', icon: SiJenkins },
  { name: 'Kubernetes', icon: SiKubernetes }
];

const TechMarquee = () => {
  const duplicatedTech = [...technologies, ...technologies];

  return (
    <div className="marquee-container">
      <div className="marquee">
        {duplicatedTech.map((tech, index) => {
          const Icon = tech.icon;
          return (
            <div key={`${tech.name}-${index}`} className="tech-item">
              <Icon className="tech-icon" />
              <span className="gradient-text">{tech.name}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TechMarquee;
